export default {
	"148948b5cdc037944bca63935fdeb8cd": "確認訂單收銀台-添加地址",
	"b19b7c16503a95e44c8e6b51162bbeae": "確認訂單收銀台-選擇地址",
	"f8d4cb146e6407435ddab35663f9b64d": "暫無收貨地址",
	"4895ae1b1fee46c1699af916adc1b797": "添加地址"
}
